"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalTypes = require("../constants/ModalTypes");

var ModalTypes = _interopRequireWildcard(_ModalTypes);

var _modals = require("../actions/modals");

var ModalsActions = _interopRequireWildcard(_modals);

var _meta = require("../selectors/meta");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var isAuthenticatedChecker = function isAuthenticatedChecker(store) {
  return function (next) {
    return function (action) {
      var getState = store.getState;

      if (!(0, _meta.selectIsAuthenticated)(getState()) && action.meta && action.meta.premium) {
        var newAction = ModalsActions.showModal({
          modalType: ModalTypes.SIGN_UP,
          modalProps: {}
        });
        return next(newAction);
      }

      return next(action);
    };
  };
};

exports.default = isAuthenticatedChecker;